import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatNativeDateModule, MatOption } from '@angular/material/core';
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import {
  MatError,
  MatFormField,
  MatLabel,
  MatSuffix,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatSelect } from '@angular/material/select';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSpinnerService } from 'ngx-spinner';
import { lastValueFrom, Subject, takeUntil } from 'rxjs';
import { ApiServiceService } from '../api-service.service';
import { CommonPaginationComponent } from '../common-component-pagination/common-component-pagination.component';
import { exportAsCsvFile } from '../shared/function/exportDataToCsv';
import { SharedValidators } from '../shared/validators/shared-validators';
import { TicketingInfoComponent } from '../ticketing-info/ticketing-info.component';
@Component({
  selector: 'app-ais140-ticket-details',
  templateUrl: './ais140-ticket-details.component.html',
  styleUrls: ['./ais140-ticket-details.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatSelect,
    NgxMatSelectSearchModule,
    MatOption,
    MatError,
    MatDatepickerInput,
    MatNativeDateModule,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepicker,
    DatePipe,
    MatIcon,
    CommonPaginationComponent,
    NgxPaginationModule,
    MatAutocomplete,
    MatAutocompleteTrigger,
    MatTooltip,
    TicketingInfoComponent,
  ],
})
export class AIS140TicketDetailsComponent implements OnInit, OnDestroy {
  ticketHistoryData: {
    ticketNo: string;
    stage: string;
    activity: string;
    associated: string;
    timeStamp: string;
    status: string;
    remark: string;
    overAllStatus: string;
    // Populated from the stage's userId (a real logged-in user) when
    // present, otherwise the backend's triggeredBy label for automated
    // writes (CRM webhook, cron sweeps) - see getChangedByLabel().
    userId?: { firstName?: string; lastName?: string } | null;
    triggeredBy?: string;
  }[] = [];

  totalLength = 0;
  size = 10;
  page = 1;

  ticketRefId = '';
  uid = '';
  iccid = '';
  imei = '';
  state = '';
  vinNo = '';
  ticketNo = '';
  firmwareVersion = '';
  deviceFotaStatus = '';
  fotaId = '';
  rtoOfficeCode = '';
  rtoState = '';
  primaryIpStatus = '';
  secondaryIpStatus = '';
  thirdIpStatus = '';
  fourthIpStatus = '';
  secondaryStateEnableStatus = '';
  dealerData = {
    posCode: '',
    email: '',
    city: '',
    mobile: '',
    posName: '',
  };
  certificateExpiryTime = '';
  fotaBatchDeviceDataObj = {
    batchId: {
      batchId: '',
    },
    currentFirmwareVersion: '',
    targetFirmwareVersion: '',
    deviceFotaStatus: '',
    progress: '',
    govtIp1: '',
    govtPort1: '',
    govtIp2: '',
    govtPort2: '',
    govtIp3: '',
    govtPort3: '',
    govtIp4: '',
    govtPort4: '',
    stateEnable: '',
    stateEnableSetStatus: '',
    secondaryStateEnable: '',
    secondaryStateEnableSetStatus: '',
  };
  deviceData = {
    BatchId: '',
    currentFirmware: '',
    assignedFirmware: '',
    fotaStatus: '',
    fotaProgress: '',
    otaPrimaryIp: '',
    otaPrimaryIpStatus: '',
    otaSecondaryIp: '',
    otaSecondaryIpStatus: '',
    stateEnableOtaStatus: '',
  };
  ignitionStatus = false;
  isFotaRequired = true;
  forceStageEnable = false;
  enableRemark = false;
  forceStageEnableReason = '';
  stageEnableRemark = '';
  disableRemark = false;
  loggedId = '';

  // Certificate Upload Sub Section
  selectedVehicleCertificateFile: File | null = null;
  selectedBackendCertificateFile: File | null = null;
  selectedOtherCertificateFiles: File[] = [];

  uploadedBackendCertificate = '';
  uploadedVahanCertificate = '';
  otherCertificate: string[] = [];

  stateUser: {
    _id: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }[] = [];
  filteredStateUser: {
    _id: string;
    firstName: string;
    lastName: string;
    fullName: string;
  }[] = [];
  nameFilterCtrl: FormControl = new FormControl('');

  myActivationsDetailsForm: FormGroup = this.formBuilder.group({});
  fileNameForm: FormGroup = this.formBuilder.group({});
  fotaForm: FormGroup = this.formBuilder.group({});
  private _onDestroy = new Subject<void>();
  today = new Date();

  userPermission = [];

  MyActivationsView = false;
  MyActivationsUpdate = false;
  isUpdateDeviceStatus = false;
  updateButtonVisible = false;

  MyActivationsViewMasterAccess = false;
  MyActivationsUpdateMasterAccess = false;

  ticketDetails = {
    backendCertificateName: '',
    vahanCertificateName: '',
    otherCertificateName: '',
    fotaRequiredFlag: false,
    forceStageEnable: false,
    forceStageEnableReason: '',
    stageEnableRemark: '',
    dealerCode: '',
    iccid: '',
    imei: '',
    uid: '',
    modelname: '',
    state: '',
    RMN: '',
    altRMN: '',
    ownerEmail: '',
    devicemake: '',
    primaryOperator: '',
    primaryMobNo: '',
    secondaryOperator: '',
    secondaryMobNo: '',
    ownerfirstName: '',
    ownerMiddleName: '',
    ownerLastName: '',
    poaDocName: '',
    poaDocNo: '',
    poiDoc: '',
    address: '',
    poiDocNo: '',
    ticketNo: '',
    vinNo: '',
    rtoOfficeCode: '',
    rtoState: '',
    fotaBatchRef: '',
    deviceType: '',
    ticketStage: [
      {
        stage: '',
        activity: '',
        associated: '',
        timeStamp: '',
        status: '',
        remark: '',
      },
    ],
    remarkbyaccolade: '',
    stageSecond: '',
    assignedTo: '',
    skippedBy: '',
    skippedName: '',
    certificateStartDate: null,
    certificateExpiryDate: null,
    _id: '',
    fileLocation: '',
    ticketEndDate: null as Date | null,
    posCode: '',
    userData: [
      {
        firstName: '',
        lastName: '',
        email: '',
      },
    ],
    ticketStartDate: null,
    assignDate: '',
    certificateExpiry: null,
    overAllRemark: '',
    InstitutionalSales: '',
    ticketDescription: '',
    vehiclemodel: '',
    mfgyear: '',
    enginenumber: '',
    regNo: '',
    invoicedate: null,
    invoiceNo: '',
    vehiclemake: '',
    certificateSentToCustomer: false,
  };

  // Prevent repeated automatic creation of FOTA batches during a single UI session
  autoCreatedFotaBatch = false;

  stage1Associated1: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage1Associated2: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage1Associated3: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage2Associated1: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage2Associated2: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage3Associated1: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage3Associated2: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage3Associated3: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;
  stage4Associated1: {
    associated: string;
    activity: string;
    status: string;
    stage: string;
    remark: string;
  } | null = null;

  fotaStatus = false;
  certificates = false;

  ticketInfoDrop = false;
  deviceInfoDrop = false;
  ownerInfoDrop = false;
  vehicleInfoDrop = false;
  dealerInfoDrop = false;
  fotaStatusInfoDrop = false;

  stage1Drop = false;
  stage2Drop = false;
  stage3Drop = false;
  stage4Drop = false;

  stageSelectControl = {
    stage1status1: '',
    stage1status2: '',
    stage1status3: '',
    stage2status1: '',
    stage2status2: '',
    stage3status1: '',
    stage3status2: '',
    stage3status3: '',
    stage4status1: '',
    stage4remark1: '',
  };

  simplifiedTicketStatus: Record<string, string> = {
    STS_CO_01: 'Not Assigned',
    STS_CO_02: 'Assigned',
    STS_CO_03: 'Started',
    STS_CO_04: 'In Queue',
    STS_CO_05: 'In Progress',
    STS_CO_06: 'Completed',
    STS_CO_07: 'On Hold Due to Vehicle Not Available',
    STS_CO_08: 'On Hold Due to Ignition Not ON',
    STS_CO_09: 'On Hold Due to GSM Network Not Available',
    STS_CO_10: 'On Hold Due to Invalid GPS',
    STS_CO_11: 'On Hold Due To Vahan Portal Down',
    STS_CO_12: 'On Hold Due to Data not Available on VAHAN',
    STS_CO_13: 'On Hold Due to Backend Portal Down',
    STS_CO_14: 'On Hold Due to Panic Event Not Confirmed',
    STS_CO_15: 'On Hold Due to OTP not being received',
    STS_CO_16: 'On Hold Due to Live Location Pending from Backend',
    STS_CO_17: 'On Hold Due to Waiting for RTO Approval',
    STS_CO_18: 'Ticket Completed and Closed',
    STS_CO_19: 'Ticket Generated but Data Not Received from CRM',
    STS_CO_20: 'Ticket Cancelled Due to Change Request Device Change',
    STS_CO_21: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    STS_CO_22: 'Ticket Cancelled Due to Change Request RTO or State Change',
    STS_CO_23: 'Ticket Cancelled as per Request',
    STS_CO_24: 'Ticket Cancelled Due to Invoice Cancelled',
    STS_CO_25: 'Change required from CRM',
    STS_CO_26: 'Other',
    STS_CO_28: 'On Hold Due to Non-Working Hours',
    STS_CO_29: 'On Hold Due to SIM Validity Issue',
    STS_CO_30: 'Ticket Suspended Due to Customer Not Responding',
    STS_CO_31: 'On Hold Due to No Response from Customer',
    STS_CO_32: 'On Hold Due to Customer Details Mismatch',
  };

  ticketStatus = [
    {
      statusCode: 'STS_CO_01',
      status: 'Not Assigned',
    },
    {
      statusCode: 'STS_CO_02',
      status: 'Assigned',
    },
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_04',
      status: 'In Queue',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_07',
      status: 'On Hold Due to Vehicle Not Available',
    },
    {
      statusCode: 'STS_CO_08',
      status: 'On Hold Due to Ignition Not ON',
    },
    {
      statusCode: 'STS_CO_09',
      status: 'On Hold Due to GSM Network Not Available',
    },
    {
      statusCode: 'STS_CO_10',
      status: 'On Hold Due to Invalid GPS',
    },
    {
      statusCode: 'STS_CO_11',
      status: 'On Hold Due To Vahan Portal Down',
    },
    {
      statusCode: 'STS_CO_12',
      status: 'On Hold Due to Data not Available on VAHAN',
    },
    {
      statusCode: 'STS_CO_13',
      status: 'On Hold Due to Backend Portal Down',
    },
    {
      statusCode: 'STS_CO_14',
      status: 'On Hold Due to Panic Event Not Confirmed',
    },
    {
      statusCode: 'STS_CO_15',
      status: 'On Hold Due to OTP not being received',
    },
    {
      statusCode: 'STS_CO_16',
      status: 'On Hold Due to Live Location Pending from Backend',
    },
    {
      statusCode: 'STS_CO_17',
      status: 'On Hold Due to Waiting for RTO Approval',
    },
    {
      statusCode: 'STS_CO_18',
      status: 'Ticket Completed and Closed',
    },
    {
      statusCode: 'STS_CO_19',
      status: 'Ticket Generated but Data Not Received from CRM',
    },
    {
      statusCode: 'STS_CO_20',
      status: 'Ticket Cancelled Due to Change Request Device Change',
    },
    {
      statusCode: 'STS_CO_21',
      status: 'Ticket Cancelled Due to Change Request Vehicle Owner Change',
    },
    {
      statusCode: 'STS_CO_22',
      status: 'Ticket Cancelled Due to Change Request RTO or State Change',
    },
    {
      statusCode: 'STS_CO_23',
      status: 'Ticket Cancelled as per Request',
    },
    {
      statusCode: 'STS_CO_24',
      status: 'Ticket Cancelled Due to Invoice Cancelled',
    },
    {
      statusCode: 'STS_CO_25',
      status: 'Change required from CRM',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_29',
      status: 'On Hold Due to SIM Validity Issue',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_31',
      status: 'On Hold Due to No Response from Customer',
    },
    {
      statusCode: 'STS_CO_32',
      status: 'On Hold Due to Customer Details Mismatch',
    },
  ];
  filteredTicketStatus: {
    statusCode: string;
    status: string;
  }[] = [];
  ticketStatusFilterCtrl: FormControl = new FormControl('');

  stage1ticketStatus = [
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_07',
      status: 'On Hold Due to Vehicle Not Available',
    },
    {
      statusCode: 'STS_CO_08',
      status: 'On Hold Due to Ignition Not ON',
    },
    {
      statusCode: 'STS_CO_09',
      status: 'On Hold Due to GSM Network Not Available',
    },
    {
      statusCode: 'STS_CO_10',
      status: 'On Hold Due to Invalid GPS',
    },
    {
      statusCode: 'STS_CO_25',
      status: 'Change required from CRM',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_29',
      status: 'On Hold Due to SIM Validity Issue',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_31',
      status: 'On Hold Due to No Response from Customer',
    },
    {
      statusCode: 'STS_CO_32',
      status: 'On Hold Due to Customer Details Mismatch',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
  ];
  filteredStage1Status1TicketStatus: { statusCode: string; status: string }[] =
    [];
  ticketStage1Status1FilterCtrl: FormControl = new FormControl('');

  filteredStage1Status2TicketStatus: { statusCode: string; status: string }[] =
    [];
  ticketStage1Status2FilterCtrl: FormControl = new FormControl('');

  filteredStage1Status3TicketStatus: { statusCode: string; status: string }[] =
    [];
  ticketStage1Status3FilterCtrl: FormControl = new FormControl('');

  stage2ticketStatus = [
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_11',
      status: 'On Hold Due To Vahan Portal Down',
    },
    {
      statusCode: 'STS_CO_12',
      status: 'On Hold Due to Data not Available on VAHAN',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
  ];
  filteredStage2TicketStatus: { statusCode: string; status: string }[] = [];
  ticketStage2StatusFilterCtrl: FormControl = new FormControl('');

  stage3ticketStatus = [
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_13',
      status: 'On Hold Due to Backend Portal Down',
    },
    {
      statusCode: 'STS_CO_14',
      status: 'On Hold Due to Panic Event Not Confirmed',
    },
    {
      statusCode: 'STS_CO_15',
      status: 'On Hold Due to OTP not being received',
    },
    {
      statusCode: 'STS_CO_16',
      status: 'On Hold Due to Live Location Pending from Backend',
    },
    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
  ];
  filteredStage3TicketStatus: { statusCode: string; status: string }[] = [];
  ticketStage3StatusFilterCtrl: FormControl = new FormControl('');

  stage4ticketStatus = [
    {
      statusCode: 'STS_CO_03',
      status: 'Started',
    },
    {
      statusCode: 'STS_CO_05',
      status: 'In Progress',
    },
    {
      statusCode: 'STS_CO_06',
      status: 'Completed',
    },
    {
      statusCode: 'STS_CO_17',
      status: 'On Hold Due to Waiting for RTO Approval',
    },

    {
      statusCode: 'STS_CO_28',
      status: 'On Hold Due to Non-Working Hours',
    },
    {
      statusCode: 'STS_CO_30',
      status: 'Ticket Suspended Due to Customer Not Responding',
    },
    {
      statusCode: 'STS_CO_26',
      status: 'Other',
    },
  ];
  filteredStage4TicketStatus: { statusCode: string; status: string }[] = [];
  ticketStage4StatusFilterCtrl: FormControl = new FormControl('');

  remarks: string[] = [
    'Device Not Responding',
    'Device Replacement',
    'Device Mismatch',
    'Customer Not Cooperative',
    'Wrong RMN Received',
    'Panic Wire Cut',
    'Panic Button Not Pressed',
    'Vehicle Offline',
    'Local Vendor Tagged',
    'Old Vehicle',
    'Customer Did Not Answer the Call',
    'Refunded',
    'Vehicle in Workshop',
    'Vehicle in Body Shop',
    'Vehicle Not Available',
    'Driver Not Available',
    'Accident-Damaged Vehicle',
    'Incorrect Customer Details Received',
    'Dealer and Customer Not Responding',
    'Mobile Number Not Whitelisted',
    'SIM Validity Short',
    'SIM Card Not Active',
    'Customer Requested a Refund',
    'Incorrect Chassis Payment',
    'Backend Portal Issue',
    'VLTD not getting print',
    'Chassis and Engine Numbers Mismatched',
    'Vehicle Untagged',
    'Vehicle Outside RTO Boundary',
    'GPS False',
  ];

  constructor(
    public apiMicroservice: ApiServiceService,
    private formBuilder: FormBuilder,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.checkPermission();
    if (this.MyActivationsView) {
      this.setTicketDetailsForms();
      this.uid = sessionStorage.getItem('uidRef') || '';
      this.ticketRefId = this.route.snapshot.paramMap.get('id') || '';
      this.fetchList();
      if (this.MyActivationsViewMasterAccess) {
        this.getStateUser();
      }
    }
  }

  checkPermission() {
    this.userPermission = JSON.parse(
      this.apiMicroservice.decryptData(
        sessionStorage.getItem('userPermission') || '[]'
      )
    );
    this.loggedId = this.apiMicroservice.decryptData(
      sessionStorage.getItem('userRefId') || ''
    );
    this.userPermission.forEach(
      (element: {
        pageName: string;
        view: boolean;
        create: boolean;
        delete: boolean;
        update: boolean;
      }) => {
        if (
          element.pageName === 'My Ticket Details page' &&
          element.view === false
        ) {
          this.navigateBack();
        }
        if (
          element.pageName === 'My Ticket Details page' &&
          element.view === true
        ) {
          this.MyActivationsView = true;
        }
        if (
          element.pageName === 'My Ticket Details page' &&
          element.update === true
        ) {
          this.MyActivationsUpdate = true;
        }
        if (
          element.pageName === 'My AIS 140 Tickets Master Access' &&
          element.view === true
        ) {
          this.MyActivationsViewMasterAccess = true;
        }
        if (
          element.pageName === 'My AIS 140 Tickets Master Access' &&
          element.update === true
        ) {
          this.MyActivationsUpdateMasterAccess = true;
        }
      }
    );
  }

  setTicketDetailsForms() {
    this.myActivationsDetailsForm = this.formBuilder.group({
      ticketNo: new FormControl(''),
      vinNo: new FormControl('', [Validators.required]),
      assignedTo: new FormControl(''),
      remarkbyaccolade: new FormControl('', [Validators.required]),

      activity1: new FormControl('FOTA / OTA Activities'),
      stage1: new FormControl(''),
      stage1Associated1: new FormControl(
        'Dealer Request / Vehicle Ignition On'
      ),
      stage1Associated2: new FormControl('GSM Network Availability'),
      stage1Associated3: new FormControl('GPS Fix availability'),
      stage1status1: new FormControl({ value: '', disabled: true }),
      stage1status2: new FormControl({ value: '', disabled: true }),
      stage1status3: new FormControl({ value: '', disabled: true }),
      stage1remark1: new FormControl({ value: '', disabled: true }),
      stage1remark2: new FormControl({ value: '', disabled: true }),
      stage1remark3: new FormControl({ value: '', disabled: true }),

      activity2: new FormControl('Vahan Certification'),
      stage2: new FormControl(''),
      stage2Associated1: new FormControl('Vahan Portal Availability'),
      stage2Associated2: new FormControl('Vehicle Data availability on Vahan'),
      stage2status1: new FormControl({ value: '', disabled: true }),
      stage2status2: new FormControl({ value: '', disabled: true }),
      stage2remark1: new FormControl({ value: '', disabled: true }),
      stage2remark2: new FormControl({ value: '', disabled: true }),

      activity3: new FormControl('AIS-140 Certification'),
      stage3: new FormControl(''),
      stage3Associated1: new FormControl('Backend Portal Availability'),
      stage3Associated2: new FormControl('Panic Event Confirmation'),
      stage3Associated3: new FormControl('OTP / Live Location Fetching'),
      stage3status1: new FormControl({ value: '', disabled: true }),
      stage3status2: new FormControl({ value: '', disabled: true }),
      stage3status3: new FormControl({ value: '', disabled: true }),
      stage3remark1: new FormControl({ value: '', disabled: true }),
      stage3remark2: new FormControl({ value: '', disabled: true }),
      stage3remark3: new FormControl({ value: '', disabled: true }),

      activity4: new FormControl('Certificate Generation / Submission'),
      stage4: new FormControl(''),
      stage4Associated1: new FormControl('AEPL'),
      stage4status1: new FormControl({ value: '', disabled: true }),
      stage4remark1: new FormControl({ value: '', disabled: true }),

      stageSecond: new FormControl(false),
      forceStageEnable: new FormControl(''),
      forceStageEnableReason: new FormControl(''),
      stageEnableRemark: new FormControl(''),
      skippedBy: new FormControl(''),
      skippedName: new FormControl(''),
      fotaBatchRef: new FormControl(''),

      certificateStartDate: new FormControl(''),
      certificateExpiryDate: new FormControl(''),
      vahanCertificateName: new FormControl(''),
      backendCertificateName: new FormControl(''),
    });

    this.fileNameForm = this.formBuilder.group({
      vahanCertificateName: new FormControl(''),
      backendCertificateName: new FormControl(''),
      otherCertificate: new FormControl(''),
    });
  }

  // Cleanup subscriptions
  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  filteredRemarks(value: string | null): string[] {
    if (!value) {
      return this.remarks;
    }

    const filterValue = value.toLowerCase();

    return this.remarks.filter((option) =>
      option.toLowerCase().includes(filterValue)
    );
  }

  fetchList() {
    this.spinner.show();
    this.apiMicroservice
      .getTicketDetailsById(this.uid, this.ticketRefId)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          if (res.data.length > 0) {
            this.ticketDetails = res.data[0];
            this.uploadedBackendCertificate =
              this.ticketDetails.backendCertificateName ?? '';
            this.uploadedVahanCertificate =
              this.ticketDetails.vahanCertificateName ?? '';
            this.otherCertificate = this.ticketDetails.otherCertificateName
              ? [...this.ticketDetails.otherCertificateName]
              : [];
            this.isFotaRequired = this.ticketDetails.fotaRequiredFlag ?? true;
            this.forceStageEnable =
              this.ticketDetails.forceStageEnable ?? false;
            this.forceStageEnableReason =
              this.ticketDetails.forceStageEnableReason ?? '';
            if (this.forceStageEnableReason != '') {
              this.myActivationsDetailsForm
                .get('forceStageEnableReason')
                ?.disable();
            }
            this.stageEnableRemark = this.ticketDetails.stageEnableRemark ?? '';
            if (
              this.forceStageEnableReason === 'Other' &&
              this.stageEnableRemark != ''
            ) {
              this.enableRemark = true;
              this.disableRemark = true;
            }

            if (
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_18' ||
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_22' ||
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_21' ||
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_23' ||
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_24' ||
              this.ticketDetails?.remarkbyaccolade === 'STS_CO_20'
            ) {
              this.updateButtonVisible = false;
              if (this.MyActivationsUpdateMasterAccess) {
                this.updateButtonVisible = true;
                this.myActivationsDetailsForm
                  .get('certificateStartDate')
                  ?.enable();
                this.myActivationsDetailsForm
                  .get('certificateExpiryDate')
                  ?.enable();
                this.myActivationsDetailsForm.get('remarkbyaccolade')?.enable();
              } else {
                this.myActivationsDetailsForm
                  .get('certificateStartDate')
                  ?.disable();
                this.myActivationsDetailsForm
                  .get('certificateExpiryDate')
                  ?.disable();
                this.myActivationsDetailsForm
                  .get('remarkbyaccolade')
                  ?.disable();
              }
            } else {
              this.updateButtonVisible = true;
              this.myActivationsDetailsForm
                .get('certificateStartDate')
                ?.enable();
              this.myActivationsDetailsForm
                .get('certificateExpiryDate')
                ?.enable();
              this.myActivationsDetailsForm.get('remarkbyaccolade')?.enable();
            }

            this.updateTicketRemarkList();
            if (this.ticketDetails.dealerCode) {
              this.apiMicroservice
                .getDealerByDealerCode(this.ticketDetails.dealerCode)
                .pipe(takeUntil(this._onDestroy))
                .subscribe((res) => {
                  if (res.status) {
                    // this.dealerData = this.ticketDetails;
                    this.dealerData = res.data;
                  }
                });
            }

            this.iccid = this.ticketDetails.iccid;
            this.imei = this.ticketDetails.imei;
            this.state = this.ticketDetails.state;
            this.ticketNo = this.ticketDetails.ticketNo;
            this.vinNo = this.ticketDetails.vinNo;
            this.rtoOfficeCode = this.ticketDetails.rtoOfficeCode;
            this.rtoState = this.ticketDetails.rtoState;
            this.deviceFotaStatus = '';
            this.getIgnitionStatus();

            if (this.isFotaRequired) {
              if (this.ticketDetails.fotaBatchRef) {
                if (this.ticketDetails.deviceType === 'ATCU2G') {
                  this.fotaStatus = false;
                  this.fetch2GFota(
                    1,
                    5,
                    this.ticketDetails.fotaBatchRef,
                    '',
                    '',
                    ''
                  );
                } else if (this.ticketDetails.deviceType === 'ATCU4G') {
                  this.fotaStatus = false;
                  this.fetchFota(
                    1,
                    5,
                    this.ticketDetails.fotaBatchRef,
                    '',
                    '',
                    ''
                  );
                  // if (this.ticketDetails.deviceType === 'ATCU2G') {
                  //   this.fetchTCU2GFotaDeviceData();
                  // }
                }
              } else if (this.ticketDetails.deviceType === 'ATCU2G') {
                this.fetchTCU2GFotaDeviceData();
              } else {
                this.setStages(this.ticketDetails.ticketStage);
                this.apiMicroservice.openSnackbar(
                  'Something wrong with FOTA batch. Please contact Server Support'
                );
                const payload = {
                  stateCode: this.ticketDetails.rtoState,
                  vinNo: this.ticketDetails.vinNo,
                  uid: this.ticketDetails.uid,
                  imei: this.ticketDetails.imei,
                  model: '4G',
                  ticketNo: this.ticketDetails.ticketNo,
                };
                // Avoid repeated auto-creation: create batch only once per UI session
                if (!this.autoCreatedFotaBatch) {
                  this.apiMicroservice
                    .createAutoAis140FotaBatch(payload)
                    .pipe(takeUntil(this._onDestroy))
                    .subscribe({
                      next: (res) => {
                        // update local model so subsequent refreshes in this session
                        // won't re-trigger the auto-creation
                        const newBatchId = res?.data?._id || '';
                        this.ticketDetails.fotaBatchRef = newBatchId;
                        this.autoCreatedFotaBatch = true;
                        this.myActivationsDetailsForm
                          .get('fotaBatchRef')
                          ?.patchValue(newBatchId);

                        // proceed with uploading certificates / next steps
                        this.ticketAddAndUploadCertificates();
                      },
                      error: (err) => {
                        this.apiMicroservice.openSnackbar(
                          err.error.message || 'Data Not Found.'
                        );
                        this.spinner.hide();
                      },
                    });
                }
              }
            } else {
              this.setStages(this.ticketDetails.ticketStage);
            }

            this.myActivationsDetailsForm
              .get('vinNo')
              ?.patchValue(this.ticketDetails.vinNo);
            this.myActivationsDetailsForm
              .get('ticketNo')
              ?.patchValue(this.ticketDetails.ticketNo);
            this.myActivationsDetailsForm
              .get('remarkbyaccolade')
              ?.patchValue(this.ticketDetails.remarkbyaccolade);
            this.myActivationsDetailsForm
              .get('vahanCertificateName')
              ?.patchValue(this.ticketDetails.vahanCertificateName);
            this.myActivationsDetailsForm
              .get('backendCertificateName')
              ?.patchValue(this.ticketDetails.backendCertificateName);
            this.myActivationsDetailsForm
              .get('stageSecond')
              ?.patchValue(this.ticketDetails.stageSecond);
            this.myActivationsDetailsForm
              .get('forceStageEnable')
              ?.patchValue(
                this.ticketDetails.forceStageEnable
                  ? this.ticketDetails.forceStageEnable
                  : false
              );
            this.myActivationsDetailsForm
              .get('forceStageEnableReason')
              ?.patchValue(
                this.ticketDetails.forceStageEnableReason
                  ? this.ticketDetails.forceStageEnableReason
                  : ''
              );
            this.myActivationsDetailsForm
              .get('stageEnableRemark')
              ?.patchValue(
                this.ticketDetails.stageEnableRemark
                  ? this.ticketDetails.stageEnableRemark
                  : ''
              );
            this.myActivationsDetailsForm
              .get('assignedTo')
              ?.patchValue(this.ticketDetails.assignedTo);
            this.myActivationsDetailsForm
              .get('skippedBy')
              ?.patchValue(
                this.ticketDetails.skippedBy ? this.ticketDetails.skippedBy : ''
              );
            this.myActivationsDetailsForm
              .get('skippedName')
              ?.patchValue(this.ticketDetails.skippedName);
            this.myActivationsDetailsForm
              .get('fotaBatchRef')
              ?.patchValue(this.ticketDetails.fotaBatchRef);
            this.myActivationsDetailsForm
              .get('certificateStartDate')
              ?.patchValue(this.ticketDetails.certificateStartDate);
            this.myActivationsDetailsForm
              .get('certificateExpiryDate')
              ?.patchValue(this.ticketDetails.certificateExpiryDate);

            const startDate = this.ticketDetails.certificateStartDate;
            const expiryDate = this.ticketDetails.certificateExpiryDate;

            if (startDate && expiryDate) {
              const start = new Date(startDate);
              const end = new Date(expiryDate);

              // Calculate the difference in milliseconds and convert to years
              const diffInYears =
                (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24 * 365);

              // Round up the difference and set to `certificateExpiryTime`
              this.certificateExpiryTime = Math.ceil(diffInYears).toString();
            } else {
              // Set to an empty string if dates are not available
              this.certificateExpiryTime = '';
            }

            this.myActivationsDetailsForm.updateValueAndValidity();
            this.spinner.hide();
          } else {
            this.apiMicroservice.openSnackbar('Data Not Found.');
            this.spinner.hide();
          }
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(
            err.error.message || 'Data Not Found.'
          );
          this.spinner.hide();
        },
      });
  }

  async setStages(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    if (ticketStageArray.length === 0) {
      this.myActivationsDetailsForm
        .get('activity1')
        ?.patchValue('FOTA / OTA Activities');
      this.myActivationsDetailsForm
        .get('stage1Associated1')
        ?.patchValue('Dealer Request / Vehicle Ignition On');
      this.myActivationsDetailsForm
        .get('stage1Associated2')
        ?.patchValue('GSM Network Availability');
      this.myActivationsDetailsForm
        .get('stage1Associated3')
        ?.patchValue('GPS Fix availability');
      this.myActivationsDetailsForm.get('stage1status1')?.enable();
      this.myActivationsDetailsForm.get('stage1remark1')?.enable();
      this.myActivationsDetailsForm.get('stage1')?.patchValue('Stage 1');
      this.myActivationsDetailsForm.get('stage1status1')?.patchValue('');
      this.myActivationsDetailsForm.get('stage1remark1')?.patchValue('');
    } else {
      await this.getStage1Associated1(ticketStageArray);
      await this.getStage1Associated2(ticketStageArray);
      await this.getStage1Associated3(ticketStageArray);
      await this.getStage2Associated1(ticketStageArray);
      await this.getStage2Associated2(ticketStageArray);
      await this.getStage3Associated1(ticketStageArray);
      await this.getStage3Associated2(ticketStageArray);
      await this.getStage3Associated3(ticketStageArray);
      await this.getStage4Associated1(ticketStageArray);
    }
    await this.checkStageToggle();
    this.stageSelectControl = this.myActivationsDetailsForm.getRawValue();
  }

  async getLatestMatchingStage(
    dataArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[],
    stage: string,
    activity: string,
    associated: string
  ) {
    if (!Array.isArray(dataArray)) return null;

    // Normalize helper (removes extra spaces)
    const normalize = (str: string) => str?.replace(/\s+/g, ' ').trim() || '';

    const normStage = normalize(stage);
    const normActivity = normalize(activity);
    const normAssociated = normalize(associated);

    let latest = null;

    for (const item of dataArray) {
      if (
        normalize(item.stage) === normStage &&
        normalize(item.activity) === normActivity &&
        normalize(item.associated) === normAssociated
      ) {
        if (!latest || new Date(item.timeStamp) > new Date(latest.timeStamp)) {
          latest = item; // keep the latest one
        }
      }
    }
    if (latest) {
      const { timeStamp, ...latestWithoutTimestamp } = latest;
      latest = latestWithoutTimestamp as {
        stage: string;
        activity: string;
        associated: string;
        status: string;
        remark: string;
      };
    }
    return latest;
  }

  async getStage1Associated1(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 1',
        'FOTA / OTA Activities',
        'Dealer Request / Vehicle Ignition On'
      );
      this.myActivationsDetailsForm
        .get('activity1')
        ?.patchValue('FOTA / OTA Activities');
      this.myActivationsDetailsForm
        .get('stage1Associated1')
        ?.patchValue('Dealer Request / Vehicle Ignition On');
      this.myActivationsDetailsForm
        .get('stage1Associated2')
        ?.patchValue('GSM Network Availability');
      this.myActivationsDetailsForm
        .get('stage1Associated3')
        ?.patchValue('GPS Fix availability');
      if (latestMatchingStage) {
        this.stage1Associated1 = latestMatchingStage;
        if (this.stage1Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage1status1')?.disable();
          this.myActivationsDetailsForm.get('stage1remark1')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage1status1')?.enable();
          this.myActivationsDetailsForm.get('stage1remark1')?.enable();
        }
        this.myActivationsDetailsForm
          .get('stage1')
          ?.patchValue(this.stage1Associated1?.stage ?? '');
        this.myActivationsDetailsForm
          .get('stage1status1')
          ?.patchValue(this.stage1Associated1?.status ?? '');
        this.myActivationsDetailsForm
          .get('stage1remark1')
          ?.patchValue(this.stage1Associated1?.remark ?? '');
      }
    } catch (err) {
      console.error('Error fetching ticket stage: getStage1Associated1 :', err);
    }
  }

  async getStage1Associated2(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 1',
        'FOTA / OTA Activities',
        'GSM Network Availability'
      );

      if (latestMatchingStage) {
        this.stage1Associated2 = latestMatchingStage;
        if (this.stage1Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage1status2')?.disable();
          this.myActivationsDetailsForm.get('stage1remark2')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage1status2')?.enable();
          this.myActivationsDetailsForm.get('stage1remark2')?.enable();
        }
      } else {
        if (this.stage1Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage1status2')?.enable();
          this.myActivationsDetailsForm.get('stage1remark2')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage1status2')
        ?.patchValue(this.stage1Associated2?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage1remark2')
        ?.patchValue(this.stage1Associated2?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage1Associated2 :', err);
    }
  }

  async getStage1Associated3(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 1',
        'FOTA / OTA Activities',
        'GPS Fix availability'
      );

      if (latestMatchingStage) {
        this.stage1Associated3 = latestMatchingStage;
        if (this.stage1Associated3?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage1status3')?.disable();
          this.myActivationsDetailsForm.get('stage1remark3')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage1status3')?.enable();
          this.myActivationsDetailsForm.get('stage1remark3')?.enable();
        }
      } else {
        if (this.stage1Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage1status3')?.enable();
          this.myActivationsDetailsForm.get('stage1remark3')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage1status3')
        ?.patchValue(this.stage1Associated3?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage1remark3')
        ?.patchValue(this.stage1Associated3?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage1Associated3 :', err);
    }
  }

  async getStage2Associated1(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 2',
        'Vahan Certification',
        'Vahan Portal Availability'
      );
      this.myActivationsDetailsForm
        .get('activity2')
        ?.patchValue('Vahan Certification');
      this.myActivationsDetailsForm
        .get('stage2Associated1')
        ?.patchValue('Vahan Portal Availability');

      this.myActivationsDetailsForm
        .get('stage2Associated2')
        ?.patchValue('Vehicle Data availability on Vahan');

      if (latestMatchingStage) {
        this.stage2Associated1 = latestMatchingStage;
        if (this.stage2Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage2status1')?.disable();
          this.myActivationsDetailsForm.get('stage2remark1')?.disable();
        } else {
          await this.stage2RestrictionRemovalOnFota();
        }
      } else {
        if (this.stage1Associated3?.status === 'STS_CO_06') {
          await this.stage2RestrictionRemovalOnFota();
        }
      }
      this.myActivationsDetailsForm
        .get('stage2')
        ?.patchValue(this.stage2Associated1?.stage ?? '');
      this.myActivationsDetailsForm
        .get('stage2status1')
        ?.patchValue(this.stage2Associated1?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage2remark1')
        ?.patchValue(this.stage2Associated1?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage2Associated1 :', err);
    }
  }

  async stage2RestrictionRemovalOnFota() {
    try {
      if (this.isFotaRequired) {
        if (this.ticketDetails.fotaBatchRef) {
          if (
            ((this.deviceFotaStatus === 'Completed' ||
              this.deviceFotaStatus === 'Skipped') &&
              this.myActivationsDetailsForm.get('stage2status1')?.disabled ==
                true &&
              this.primaryIpStatus === 'Set' &&
              this.secondaryIpStatus === 'Set') ||
            this.forceStageEnable
          ) {
            this.myActivationsDetailsForm.get('stage2status1')?.enable();
            this.myActivationsDetailsForm.get('stage2remark1')?.enable();
          }
        } else if (this.ticketDetails.deviceType === 'ATCU2G') {
          this.apiMicroservice
            .twoGFotaBatchDevice({
              ticketId: this.ticketDetails._id,
              type: 'get',
            })
            .pipe(takeUntil(this._onDestroy))
            .subscribe({
              next: (res) => {
                if (res?.data && res.data.fotaStatus === 'Completed') {
                  this.myActivationsDetailsForm.get('stage2status1')?.enable();
                  this.myActivationsDetailsForm.get('stage2remark1')?.enable();
                } else {
                  this.myActivationsDetailsForm.get('stage2status1')?.disable();
                  this.myActivationsDetailsForm.get('stage2remark1')?.disable();
                }
              },
              error: (err) => {
                this.myActivationsDetailsForm.get('stage2status1')?.disable();
                this.myActivationsDetailsForm.get('stage2remark1')?.disable();
                console.error('Error fetching ticket stage:', err);
              },
            });
        }
      } else {
        this.myActivationsDetailsForm.get('stage2status1')?.enable();
        this.myActivationsDetailsForm.get('stage2remark1')?.enable();
      }
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      this.apiMicroservice.openSnackbar('Operation Failed: ' + errorMessage);
      console.error('Error fetching FOTA batch device status:', errorMessage, {
        ticketId: this.ticketDetails._id,
        deviceType: this.ticketDetails.deviceType,
      });

      // Fallback behavior if the API call fails
      this.myActivationsDetailsForm.get('stage2status1')?.disable();
      this.myActivationsDetailsForm.get('stage2remark1')?.disable();
    }
  }

  async getStage2Associated2(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 2',
        'Vahan Certification',
        'Vehicle Data availability on Vahan'
      );

      if (latestMatchingStage) {
        this.stage2Associated2 = latestMatchingStage;
        if (this.stage2Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage2status2')?.disable();
          this.myActivationsDetailsForm.get('stage2remark2')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage2status2')?.enable();
          this.myActivationsDetailsForm.get('stage2remark2')?.enable();
        }
      } else {
        if (this.stage2Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage2status2')?.enable();
          this.myActivationsDetailsForm.get('stage2remark2')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage2status2')
        ?.patchValue(this.stage2Associated2?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage2remark2')
        ?.patchValue(this.stage2Associated2?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage2Associated2 :', err);
    }
  }

  async getStage3Associated1(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 3',
        'AIS-140 Certification',
        'Backend Portal Availability'
      );
      this.myActivationsDetailsForm
        .get('activity3')
        ?.patchValue('AIS-140 Certification');
      this.myActivationsDetailsForm
        .get('stage3Associated1')
        ?.patchValue('Backend Portal Availability');
      this.myActivationsDetailsForm
        .get('stage3Associated2')
        ?.patchValue('Panic Event Confirmation');
      this.myActivationsDetailsForm
        .get('stage3Associated3')
        ?.patchValue('OTP / Live Location Fetching');

      if (latestMatchingStage) {
        this.stage3Associated1 = latestMatchingStage;
        if (this.stage3Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status1')?.disable();
          this.myActivationsDetailsForm.get('stage3remark1')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage3status1')?.enable();
          this.myActivationsDetailsForm.get('stage3remark1')?.enable();
        }
      } else {
        if (this.stage2Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status1')?.enable();
          this.myActivationsDetailsForm.get('stage3remark1')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage3')
        ?.patchValue(this.stage3Associated1?.stage ?? '');
      this.myActivationsDetailsForm
        .get('stage3status1')
        ?.patchValue(this.stage3Associated1?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage3remark1')
        ?.patchValue(this.stage3Associated1?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage3Associated1 :', err);
    }
  }

  async getStage3Associated2(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 3',
        'AIS-140 Certification',
        'Panic Event Confirmation'
      );

      if (latestMatchingStage) {
        this.stage3Associated2 = latestMatchingStage;
        if (this.stage3Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status2')?.disable();
          this.myActivationsDetailsForm.get('stage3remark2')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage3status2')?.enable();
          this.myActivationsDetailsForm.get('stage3remark2')?.enable();
        }
      } else {
        if (this.stage3Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status2')?.enable();
          this.myActivationsDetailsForm.get('stage3remark2')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage3status2')
        ?.patchValue(this.stage3Associated2?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage3remark2')
        ?.patchValue(this.stage3Associated2?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage3Associated2 :', err);
    }
  }

  async getStage3Associated3(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 3',
        'AIS-140 Certification',
        'OTP / Live Location Fetching'
      );

      if (latestMatchingStage) {
        this.stage3Associated3 = latestMatchingStage;
        if (this.stage3Associated3?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status3')?.disable();
          this.myActivationsDetailsForm.get('stage3remark3')?.disable();
        } else {
          this.myActivationsDetailsForm.get('stage3status3')?.enable();
          this.myActivationsDetailsForm.get('stage3remark3')?.enable();
        }
      } else {
        if (this.stage3Associated2?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage3status3')?.enable();
          this.myActivationsDetailsForm.get('stage3remark3')?.enable();
        }
      }
      this.myActivationsDetailsForm
        .get('stage3status3')
        ?.patchValue(this.stage3Associated3?.status ?? '');

      this.myActivationsDetailsForm
        .get('stage3remark3')
        ?.patchValue(this.stage3Associated3?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage3Associated3 :', err);
    }
  }

  async getStage4Associated1(
    ticketStageArray: {
      stage: string;
      activity: string;
      associated: string;
      timeStamp: string;
      status: string;
      remark: string;
    }[]
  ) {
    try {
      const latestMatchingStage = await this.getLatestMatchingStage(
        ticketStageArray,
        'Stage 4',
        'Certificate Generation / Submission',
        'AEPL'
      );
      this.myActivationsDetailsForm
        .get('activity4')
        ?.patchValue('Certificate Generation / Submission');
      this.myActivationsDetailsForm
        .get('stage4Associated1')
        ?.patchValue('AEPL');

      if (latestMatchingStage) {
        this.stage4Associated1 = latestMatchingStage;
        if (this.stage4Associated1?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage4status1')?.disable();
          this.myActivationsDetailsForm.get('stage4remark1')?.disable();
          this.certificates = true;
        } else if (this.stage4Associated1?.status === 'STS_CO_17') {
          this.myActivationsDetailsForm.get('stage4status1')?.enable();
          this.myActivationsDetailsForm.get('stage4remark1')?.enable();
          this.certificates = true;
        } else {
          this.myActivationsDetailsForm.get('stage4status1')?.enable();
          this.myActivationsDetailsForm.get('stage4remark1')?.enable();
          this.certificates = false;
        }
      } else {
        if (this.stage3Associated3?.status === 'STS_CO_06') {
          this.myActivationsDetailsForm.get('stage4status1')?.enable();
          this.myActivationsDetailsForm.get('stage4remark1')?.enable();
          this.certificates = false;
        }
      }
      this.myActivationsDetailsForm
        .get('stage4')
        ?.patchValue(this.stage4Associated1?.stage ?? '');
      this.myActivationsDetailsForm
        .get('stage4status1')
        ?.patchValue(this.stage4Associated1?.status ?? '');
      this.myActivationsDetailsForm
        .get('stage4remark1')
        ?.patchValue(this.stage4Associated1?.remark ?? '');
    } catch (err) {
      console.error('Error fetching ticket stage: getStage4Associated1 :', err);
    }
  }

  updateTicketRemarkList() {
    // Ensure filter control is initialized
    if (!this.ticketStatusFilterCtrl) {
      this.ticketStatusFilterCtrl = new FormControl('');
    }

    if (
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_18' &&
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_20' &&
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_21' &&
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_22' &&
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_23' &&
      this.ticketDetails.remarkbyaccolade !== 'STS_CO_24'
    ) {
      if (!this.MyActivationsUpdateMasterAccess) {
        this.ticketStatus = this.ticketStatus.filter((el) => {
          const { statusCode } = el;
          if (
            statusCode !== 'STS_CO_19' &&
            statusCode !== 'STS_CO_20' &&
            statusCode !== 'STS_CO_21' &&
            statusCode !== 'STS_CO_22' &&
            statusCode !== 'STS_CO_24'
          ) {
            return true;
          }
          return false;
        });
      }
    }
    this.filteredTicketStatus = [...this.ticketStatus];
    this.ticketStatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredTicketStatus = [...this.ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredTicketStatus = this.ticketStatus.filter((item) =>
          item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage1Status1TicketStatus = [...this.stage1ticketStatus];
    this.ticketStage1Status1FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage1Status1TicketStatus = [...this.stage1ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage1Status1TicketStatus = this.stage1ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage1Status2TicketStatus = [...this.stage1ticketStatus];
    this.ticketStage1Status2FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage1Status2TicketStatus = [...this.stage1ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage1Status2TicketStatus = this.stage1ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage1Status3TicketStatus = [...this.stage1ticketStatus];
    this.ticketStage1Status3FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage1Status3TicketStatus = [...this.stage1ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage1Status3TicketStatus = this.stage1ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage2TicketStatus = [...this.stage2ticketStatus];
    this.ticketStage2StatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage2TicketStatus = [...this.stage2ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage2TicketStatus = this.stage2ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage3TicketStatus = [...this.stage3ticketStatus];
    this.ticketStage3StatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage3TicketStatus = [...this.stage3ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage3TicketStatus = this.stage3ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });

    this.filteredStage4TicketStatus = [...this.stage4ticketStatus];
    this.ticketStage4StatusFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search: string) => {
        if (!search) {
          this.filteredStage4TicketStatus = [...this.stage4ticketStatus];
          return;
        }

        // Filter the list based on search value
        search = search.toLowerCase();
        this.filteredStage4TicketStatus = this.stage4ticketStatus.filter(
          (item) => item.status.toLowerCase().includes(search)
        );
      });
  }

  fetchTCU2GFotaDeviceData() {
    this.apiMicroservice
      .twoGFotaBatchDevice({
        ticketId: this.ticketDetails._id,
        type: 'get',
      })
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          this.deviceData = res.data;
          this.createTcu2gFotaFormData();
        },
        error: (err) => {
          console.error(err);
          this.createTcu2gFotaFormData();
        },
      });
    this.setStages(this.ticketDetails.ticketStage);
  }

  createTcu2gFotaFormData() {
    this.fotaForm = this.formBuilder.group({
      BatchId: new FormControl(
        this.deviceData?.BatchId || '',
        Validators.required
      ),
      currentFirmware: new FormControl(
        this.deviceData?.currentFirmware || '',
        Validators.required
      ),
      assignedFirmware: new FormControl(
        this.deviceData?.assignedFirmware || '',
        Validators.required
      ),
      fotaStatus: new FormControl(
        this.deviceData?.fotaStatus || '',
        Validators.required
      ),
      fotaProgress: new FormControl(
        this.deviceData?.fotaProgress || '',
        Validators.required
      ),
      otaPrimaryIp: new FormControl(
        this.deviceData?.otaPrimaryIp || '',
        Validators.required
      ),
      otaPrimaryIpStatus: new FormControl(
        this.deviceData?.otaPrimaryIpStatus || '',
        Validators.required
      ),
      otaSecondaryIp: new FormControl(
        this.deviceData?.otaSecondaryIp || '',
        Validators.required
      ),
      otaSecondaryIpStatus: new FormControl(
        this.deviceData?.otaSecondaryIpStatus || '',
        Validators.required
      ),
      stateEnableOtaStatus: new FormControl(
        this.deviceData?.stateEnableOtaStatus || '',
        Validators.required
      ),
    });
  }

  updateTcu2gDeviceFotaData(data) {
    this.spinner.show();
    this.apiMicroservice
      .twoGFotaBatchDevice({
        type: 'save',
        ...data,
        ticketId: this.ticketDetails._id,
      })
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          this.ngOnInit();
          this.apiMicroservice.openSnackbar(res.message);
        },
        error: (err) => {
          console.error(err);
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(err.message);
        },
      });
  }

  // userAssignmentList only returns Active Support Team users, but a ticket can still be
  // assigned to a user who has since been deleted (status 'In-active') or who is outside
  // that list (e.g. the configured default assignee). Lets the template keep
  // that handler's name visible in the select instead of rendering it blank.
  isAssigneeMissingFromList(): boolean {
    const assignedTo = this.ticketDetails?.assignedTo;
    return (
      !!assignedTo &&
      this.ticketDetails?.userData?.length > 0 &&
      !this.stateUser.some((user) => user._id === assignedTo)
    );
  }

  getStateUser() {
    this.apiMicroservice
      .userAssignmentList('', '')
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.stateUser = res.data;
        this.filteredStateUser = [...this.stateUser];

        this.nameFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe((search: string) => {
            if (!search) {
              this.filteredStateUser = [...this.stateUser];
              return;
            }

            // Filter the list based on search value
            search = search.toLowerCase();
            this.filteredStateUser = this.stateUser.filter(
              (item) =>
                item.firstName.toLowerCase().includes(search) ||
                item.lastName.toLowerCase().includes(search)
            );
          });
      });
  }

  fetchFota(
    pageNo: number,
    size: number,
    fotaBatchRef: string,
    firmwareVersion: string,
    state: string,
    searchField: string
  ) {
    this.apiMicroservice
      .fotaBatchDeviceListByBatchId(
        pageNo,
        size,
        fotaBatchRef,
        firmwareVersion,
        state,
        searchField,
        'All'
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          if (res.data.batchDeviceData.length > 0) {
            this.fotaBatchDeviceDataObj = res.data.batchDeviceData[0];
            this.fotaStatus = true;
            this.deviceFotaStatus =
              res.data.batchDeviceData[0].deviceFotaStatus;
            this.primaryIpStatus = res.data.batchDeviceData[0].govtIp1SetStatus;
            this.secondaryIpStatus =
              res.data.batchDeviceData[0].govtIp2SetStatus;
            this.thirdIpStatus = res.data.batchDeviceData[0].govtIp3SetStatus;
            this.fourthIpStatus = res.data.batchDeviceData[0].govtIp4SetStatus;
            this.secondaryStateEnableStatus =
              res.data.batchDeviceData[0].secondaryStateEnableSetStatus;
          } else {
            this.fotaStatus = false;
          }
          this.setStages(this.ticketDetails.ticketStage);
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(
            err.error.message || 'Data Not Found.'
          );
          this.spinner.hide();
          this.setStages(this.ticketDetails.ticketStage);
        },
      });
  }

  fetch2GFota(
    pageNo: number,
    size: number,
    fotaBatchRef: string,
    firmwareVersion: string,
    state: string,
    searchField: string
  ) {
    this.apiMicroservice
      .fotaBatchDeviceListByBatchId2G(
        pageNo,
        size,
        fotaBatchRef,
        firmwareVersion,
        state,
        searchField
      )
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          if (res.data.batchDeviceData.length > 0) {
            this.fotaBatchDeviceDataObj = res.data.batchDeviceData[0];
            this.fotaStatus = true;
            this.deviceFotaStatus =
              res.data.batchDeviceData[0].deviceFotaStatus;
            this.primaryIpStatus = res.data.batchDeviceData[0].govtIp1SetStatus;
            this.secondaryIpStatus =
              res.data.batchDeviceData[0].govtIp2SetStatus;
            this.thirdIpStatus = res.data.batchDeviceData[0].govtIp3SetStatus;
            this.fourthIpStatus = res.data.batchDeviceData[0].govtIp4SetStatus;
            this.secondaryStateEnableStatus =
              res.data.batchDeviceData[0].secondaryStateEnableSetStatus;
          } else {
            this.fotaStatus = false;
          }
          this.setStages(this.ticketDetails.ticketStage);
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(
            err.error.message || 'Data Not Found.'
          );
          this.spinner.hide();
          this.setStages(this.ticketDetails.ticketStage);
        },
      });
  }

  remarkChange() {
    this.myActivationsDetailsForm.controls['backendCertificateName'].setValue(
      this.ticketDetails.backendCertificateName
    );
    this.myActivationsDetailsForm.controls['vahanCertificateName'].setValue(
      this.ticketDetails.vahanCertificateName
    );
  }

  checkOtherSelected() {
    const otherSelectStat =
      this.myActivationsDetailsForm.controls['forceStageEnableReason'].value;
    if (otherSelectStat === 'Other') {
      this.enableRemark = true;
    } else {
      this.enableRemark = false;
    }
  }

  checkStageEnableState() {
    const stageEnableStat =
      this.myActivationsDetailsForm.controls['forceStageEnable'].value ||
      !this.myActivationsDetailsForm.get('remarkbyaccolade')?.value;
    if (stageEnableStat) {
      return stageEnableStat;
    } else {
      return false;
    }
  }

  forceStageEnableClick() {
    this.myActivationsDetailsForm.controls[
      'forceStageEnableReason'
    ].setValidators([Validators.required]);
    this.myActivationsDetailsForm.controls[
      'forceStageEnableReason'
    ].updateValueAndValidity();
    const payload = {
      forceStageEnable: true,
      skippedBy: this.apiMicroservice.decryptData(
        sessionStorage.getItem('userRefId') || ''
      ),
      forceStageEnableReason:
        this.myActivationsDetailsForm.controls['forceStageEnableReason'].value,
      stageEnableRemark:
        this.myActivationsDetailsForm.controls['stageEnableRemark'].value,
    };

    if (payload.forceStageEnableReason != '') {
      if (
        payload.forceStageEnableReason === 'Other' &&
        payload.stageEnableRemark === ''
      ) {
        this.myActivationsDetailsForm.controls[
          'stageEnableRemark'
        ].setValidators([Validators.required]);
        this.myActivationsDetailsForm.get('stageEnableRemark')?.markAsTouched();
        this.myActivationsDetailsForm.updateValueAndValidity();
        this.apiMicroservice.openSnackbar(
          'Please enter the remark to skip Stage 2 restriction'
        );
        this.spinner.hide();
        return;
      } else {
        this.apiMicroservice
          .forceStageEnable(this.ticketRefId, payload)
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if (res) {
              this.apiMicroservice.openSnackbar('Stage Enabled');
              this.ngOnInit();
            } else {
              this.apiMicroservice.openSnackbar(res.message);
            }
          });
      }
    } else {
      this.myActivationsDetailsForm
        .get('forceStageEnableReason')
        ?.markAsTouched();
      this.apiMicroservice.openSnackbar(
        'Please Select the reason to skip Stage 2 restriction'
      );
    }
  }

  uploadVehicleCertificate(event: Event) {
    // if (
    //   confirm('Do you want to proceed with uploading the Vehicle Certificate?')
    // ) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedVehicleCertificateFile = input.files[0];
      // Update form fields
      this.fileNameForm.patchValue({
        vahanCertificateName: this.selectedVehicleCertificateFile.name, // Store file name
      });
      this.fileNameForm.controls['vahanCertificateName'].setErrors(null);
      this.fileNameForm.controls['vahanCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'vahanCertificateName'
      ].updateValueAndValidity();

      this.fileNameForm.controls['backendCertificateName'].setErrors(null);
      this.fileNameForm.controls['backendCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'backendCertificateName'
      ].updateValueAndValidity();
      this.uploadVehicleCertificate_Update();
    } else {
      this.selectedVehicleCertificateFile = null;
      // Reset values if no file is selected
      this.fileNameForm.patchValue({
        vahanCertificateName: '',
      });
    }
    // }
  }

  backendCertificate_upload(event: Event) {
    // if (
    //   confirm('Do you want to proceed with uploading the Backend Certificate?')
    // ) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedBackendCertificateFile = input.files[0];
      // Update form fields
      this.fileNameForm.patchValue({
        backendCertificateName: this.selectedBackendCertificateFile.name, // Store file name
      });
      this.fileNameForm.controls['vahanCertificateName'].setErrors(null);
      this.fileNameForm.controls['vahanCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'vahanCertificateName'
      ].updateValueAndValidity();

      this.fileNameForm.controls['backendCertificateName'].setErrors(null);
      this.fileNameForm.controls['backendCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'backendCertificateName'
      ].updateValueAndValidity();
      this.uploadBackendCertificate_Update();
    } else {
      this.selectedBackendCertificateFile = null;
      // Reset values if no file is selected
      this.fileNameForm.patchValue({
        backendCertificateName: '',
      });
    }
    // }
  }

  otherCertificate_upload(event: Event) {
    // if (
    //   confirm('Do you want to proceed with uploading the Other Certificates?')
    // ) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedOtherCertificateFiles = Array.from(input.files);

      // Extract file names
      const fileNames = this.selectedOtherCertificateFiles
        .map((file) => file.name)
        .join(', ');

      // Update form fields
      this.fileNameForm.patchValue({
        otherCertificate: fileNames, // Store file name
      });
      this.uploadOtherCertificate_Update();
    } else {
      this.selectedOtherCertificateFiles = [];
      // Reset values if no file is selected
      this.fileNameForm.patchValue({
        otherCertificate: '',
      });
    }
    // }
  }

  downloadCertificate(type: string) {
    let fileLocation = '';
    if (type === 'vahan') {
      fileLocation =
        this.ticketDetails.fileLocation +
        this.ticketDetails.vahanCertificateName;
    } else if (type === 'backend') {
      fileLocation =
        this.ticketDetails.fileLocation +
        this.ticketDetails.backendCertificateName;
    } else {
      fileLocation = this.ticketDetails.fileLocation + type;
    }
    fileLocation.substring(1);
    this.spinner.show();
    this.apiMicroservice
      .downloadCertificate({ fileLocation })
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          window.open(res.downloadUrl, '_blank');
          this.spinner.hide();
        },
        error: (err) => {
          this.apiMicroservice.openSnackbar(
            err.error.message || 'Error in downloading file.'
          );
          this.spinner.hide();
        },
      });
  }

  async uploadBackendCertificate_Update(): Promise<string> {
    if (!this.selectedBackendCertificateFile) {
      return '';
    }

    const formData = new FormData();
    formData.append('certificate', this.selectedBackendCertificateFile);
    formData.append('vinNo', this.ticketDetails.vinNo);
    formData.append('iccid', this.ticketDetails.iccid);
    formData.append('ticketNo', this.ticketDetails.ticketNo);

    try {
      await lastValueFrom(
        this.apiMicroservice.uploadBackendCertificate(formData)
      );
      this.apiMicroservice.openSnackbar(
        'Backend Certificate Uploaded Successfully'
      );
    } catch (error) {
      console.error('Backend Certificate upload failed', error);
    }

    return '';
  }

  async uploadVehicleCertificate_Update(): Promise<string> {
    if (!this.selectedVehicleCertificateFile) {
      return '';
    }

    const formData = new FormData();
    formData.append('certificate', this.selectedVehicleCertificateFile);
    formData.append('vinNo', this.ticketDetails.vinNo);
    formData.append('iccid', this.ticketDetails.iccid);
    formData.append('ticketNo', this.ticketDetails.ticketNo);

    try {
      await lastValueFrom(
        this.apiMicroservice.uploadVahanCertificate(formData)
      );
      this.apiMicroservice.openSnackbar(
        'Vehicle Certificate Uploaded Successfully'
      );
    } catch (error) {
      console.error('Vehicle Certificate upload failed', error);
    }

    return '';
  }

  async uploadOtherCertificate_Update(): Promise<string> {
    if (
      !this.selectedOtherCertificateFiles ||
      this.selectedOtherCertificateFiles.length === 0
    ) {
      return '';
    }

    try {
      await Promise.all(
        this.selectedOtherCertificateFiles.map(async (file) => {
          const formData = new FormData();
          formData.append('otherCertificate', file);
          formData.append('vinNo', this.ticketDetails.vinNo);
          formData.append('iccid', this.ticketDetails.iccid);
          formData.append('ticketNo', this.ticketDetails.ticketNo);

          try {
            await lastValueFrom(
              this.apiMicroservice.uploadOtherCertificate(formData)
            );
          } catch (error) {
            console.error('File upload failed:', error);
            this.apiMicroservice.openSnackbar('File not uploaded');
          }
        })
      );
    } catch (error) {
      console.error('Error uploading certificates:', error);
    }

    return '';
  }

  ticketRemarkClick(): boolean {
    const payload = this.myActivationsDetailsForm.getRawValue();

    payload.vahanCertificateName = this.ticketDetails.vahanCertificateName;
    payload.backendCertificateName = this.ticketDetails.backendCertificateName;

    if (!payload.vahanCertificateName && !this.selectedVehicleCertificateFile) {
      payload.vahanCertificateName = '';
    }
    if (
      !payload.backendCertificateName &&
      !this.selectedBackendCertificateFile
    ) {
      payload.backendCertificateName = '';
    }

    if (payload.remarkbyaccolade === 'STS_CO_18') {
      if (
        this.myActivationsDetailsForm.get('stage4status1')?.disabled &&
        !payload.stage4status1
      ) {
        this.apiMicroservice.openSnackbar(
          'Please complete all the Stages, fill Certificate start date and end date and then fill Certificate start date and end date.'
        );
        this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue('');
        this.spinner.hide();

        return false;
      } else {
        if (!payload.certificateStartDate || !payload.certificateExpiryDate) {
          this.myActivationsDetailsForm.controls[
            'certificateStartDate'
          ].setValidators(Validators.required);
          this.myActivationsDetailsForm.controls[
            'certificateExpiryDate'
          ].setValidators(Validators.required);

          this.myActivationsDetailsForm.controls[
            'certificateStartDate'
          ].updateValueAndValidity();
          this.myActivationsDetailsForm.controls[
            'certificateExpiryDate'
          ].updateValueAndValidity();

          this.myActivationsDetailsForm
            .get('certificateStartDate')
            ?.markAsTouched();
          this.myActivationsDetailsForm
            .get('certificateExpiryDate')
            ?.markAsTouched();

          this.apiMicroservice.openSnackbar(
            'Please fill Certificate start date and end date.'
          );
          this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue(
            ''
          );
          this.spinner.hide();

          return false;
        } else {
          this.myActivationsDetailsForm.controls[
            'certificateStartDate'
          ].setErrors(null);
          this.myActivationsDetailsForm.controls[
            'certificateStartDate'
          ].clearValidators();
          this.myActivationsDetailsForm.controls[
            'certificateStartDate'
          ].updateValueAndValidity();

          this.myActivationsDetailsForm.controls[
            'certificateExpiryDate'
          ].setErrors(null);
          this.myActivationsDetailsForm.controls[
            'certificateExpiryDate'
          ].clearValidators();
          this.myActivationsDetailsForm.controls[
            'certificateExpiryDate'
          ].updateValueAndValidity();
        }

        if (
          !payload.vahanCertificateName &&
          !payload.backendCertificateName &&
          !this.selectedVehicleCertificateFile &&
          !this.selectedBackendCertificateFile
        ) {
          this.fileNameForm.controls['vahanCertificateName'].setValidators([
            Validators.required,
          ]);
          this.fileNameForm.controls['backendCertificateName'].setValidators([
            Validators.required,
          ]);

          this.fileNameForm.controls[
            'vahanCertificateName'
          ].updateValueAndValidity();
          this.fileNameForm.controls[
            'backendCertificateName'
          ].updateValueAndValidity();

          this.fileNameForm.controls['vahanCertificateName'].markAsTouched();
          this.fileNameForm.controls['backendCertificateName'].markAsTouched();

          this.apiMicroservice.openSnackbar('Please Upload Any Certificate');
          this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue(
            ''
          );
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(
            'Please Upload Any of the two Certificates'
          );

          return false;
        } else {
          this.fileNameForm.controls['vahanCertificateName'].setErrors(null);
          this.fileNameForm.controls['vahanCertificateName'].clearValidators();
          this.fileNameForm.controls[
            'vahanCertificateName'
          ].updateValueAndValidity();

          this.fileNameForm.controls['backendCertificateName'].setErrors(null);
          this.fileNameForm.controls[
            'backendCertificateName'
          ].clearValidators();
          this.fileNameForm.controls[
            'backendCertificateName'
          ].updateValueAndValidity();
        }
      }
    }

    if (
      payload.remarkbyaccolade === 'STS_CO_18' &&
      payload.stage4status1 !== 'STS_CO_06'
    ) {
      this.apiMicroservice.openSnackbar('Please complete Stage 4');
      this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue('');
      return false;
    }

    if (
      this.myActivationsDetailsForm.get('stage4status1')?.disabled &&
      payload.stage4status1
    ) {
      if (!payload.certificateStartDate || !payload.certificateExpiryDate) {
        this.myActivationsDetailsForm.controls[
          'certificateStartDate'
        ].setValidators(Validators.required);
        this.myActivationsDetailsForm.controls[
          'certificateExpiryDate'
        ].setValidators(Validators.required);

        this.myActivationsDetailsForm.controls[
          'certificateStartDate'
        ].updateValueAndValidity();
        this.myActivationsDetailsForm.controls[
          'certificateExpiryDate'
        ].updateValueAndValidity();

        this.myActivationsDetailsForm
          .get('certificateStartDate')
          ?.markAsTouched();
        this.myActivationsDetailsForm
          .get('certificateExpiryDate')
          ?.markAsTouched();

        this.apiMicroservice.openSnackbar(
          'Please fill Certificate start date and end date.'
        );
        this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue('');
        this.spinner.hide();

        return false;
      } else if (
        !payload.vahanCertificateName &&
        !payload.backendCertificateName &&
        !this.selectedVehicleCertificateFile &&
        !this.selectedBackendCertificateFile
      ) {
        this.fileNameForm.controls['vahanCertificateName'].setValidators([
          Validators.required,
        ]);
        this.fileNameForm.controls['backendCertificateName'].setValidators([
          Validators.required,
        ]);

        this.fileNameForm.controls[
          'vahanCertificateName'
        ].updateValueAndValidity();
        this.fileNameForm.controls[
          'backendCertificateName'
        ].updateValueAndValidity();

        this.fileNameForm.controls['vahanCertificateName'].markAsTouched();
        this.fileNameForm.controls['backendCertificateName'].markAsTouched();

        this.apiMicroservice.openSnackbar('Please Upload Any Certificate');
        this.myActivationsDetailsForm.controls['remarkbyaccolade'].setValue('');
        this.spinner.hide();
        this.apiMicroservice.openSnackbar(
          'Please Upload Any of the two Certificates'
        );

        return false;
      }
    } else {
      this.myActivationsDetailsForm.controls['certificateStartDate'].setErrors(
        null
      );
      this.myActivationsDetailsForm.controls[
        'certificateStartDate'
      ].clearValidators();
      this.myActivationsDetailsForm.controls[
        'certificateStartDate'
      ].updateValueAndValidity();

      this.myActivationsDetailsForm.controls['certificateExpiryDate'].setErrors(
        null
      );
      this.myActivationsDetailsForm.controls[
        'certificateExpiryDate'
      ].clearValidators();
      this.myActivationsDetailsForm.controls[
        'certificateExpiryDate'
      ].updateValueAndValidity();

      this.fileNameForm.controls['vahanCertificateName'].setErrors(null);
      this.fileNameForm.controls['vahanCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'vahanCertificateName'
      ].updateValueAndValidity();

      this.fileNameForm.controls['backendCertificateName'].setErrors(null);
      this.fileNameForm.controls['backendCertificateName'].clearValidators();
      this.fileNameForm.controls[
        'backendCertificateName'
      ].updateValueAndValidity();
    }

    return true; // Validation passed
  }

  ticketAddAndUploadCertificates() {
    if (this.myActivationsDetailsForm.invalid || this.fileNameForm.invalid) {
      SharedValidators.markAllAsTouched(this.myActivationsDetailsForm);
      SharedValidators.markAllAsTouched(this.fileNameForm);
      // this.apiMicroservice.openSnackbar("Please enter all the required data");
      return;
    } else {
      this.ticketAdd();
    }
  }

  resendCertificates(): void {
    const pattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (
      this.ticketDetails.ownerEmail &&
      !pattern.test(this.ticketDetails.ownerEmail)
    ) {
      this.apiMicroservice.openSnackbar('Please enter a valid Email ID.');
    }

    if (
      !this.ticketDetails.backendCertificateName &&
      !this.ticketDetails.vahanCertificateName
    ) {
      this.apiMicroservice.openSnackbar(
        'Certificate is not available to resend.'
      );
      return;
    }

    this.spinner.show();

    const payload = {
      ticketNo: this.ticketDetails.ticketNo,
      vinNo: this.ticketDetails.vinNo,
    };

    this.apiMicroservice
      .resendCertificateToCustomer(payload)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          this.spinner.hide();

          if (res?.status) {
            this.apiMicroservice.openSnackbar(
              'Certificate email resent successfully.'
            );
          } else {
            this.apiMicroservice.openSnackbar(
              res?.message || 'Failed to resend certificate email.'
            );
          }
        },
        error: (err) => {
          this.spinner.hide();

          this.apiMicroservice.openSnackbar(
            err?.error?.message || 'Failed to resend certificate email.'
          );
        },
      });
  }

  ticketAdd() {
    const payload = this.myActivationsDetailsForm.getRawValue();

    const value =
      this.myActivationsDetailsForm.controls['forceStageEnableReason'].value;
    const remark =
      this.myActivationsDetailsForm.controls['stageEnableRemark'].value;
    if (value === 'Other' && remark === '') {
      this.spinner.hide();
      this.enableRemark = true;
      this.myActivationsDetailsForm.controls['stageEnableRemark'].setValidators(
        [Validators.required]
      );
      this.myActivationsDetailsForm.get('stageEnableRemark')?.markAsTouched();
      this.myActivationsDetailsForm.updateValueAndValidity();
      this.apiMicroservice.openSnackbar(
        'Please enter the remark to skip Stage 2 restriction'
      );
      return;
    }

    if (!this.ticketRemarkClick()) {
      return; // Stop execution if validation fails
    }

    if (this.myActivationsDetailsForm.valid) {
      const ticketPayload = {} as {
        ticketNo: string;
        vinNo: string;
        stage: string;
        associated: string;
        activity: string;
        status: string;
        remark: string;
        certificateStartDate: string;
        certificateExpiryDate: string;
        remarkbyaccolade: string;
        imei: string;
        refId: string;
        userRef: string;
        fotaBatchRef: string;
      };
      ticketPayload['ticketNo'] = this.ticketDetails.ticketNo;
      ticketPayload['vinNo'] = this.ticketDetails.vinNo;
      if (
        (!this.myActivationsDetailsForm.get('stage4status1')?.disabled &&
          payload.stage4status1 !== 'STS_CO_06') ||
        payload.stage4status1 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 4';
        ticketPayload['associated'] = payload.stage4Associated1;
        ticketPayload['activity'] = 'Certificate Generation / Submission';
        ticketPayload['status'] = payload.stage4status1;
        ticketPayload['remark'] = payload.stage4remark1;
      } else if (
        (!this.myActivationsDetailsForm.get('stage3status3')?.disabled &&
          payload.stage3status3 !== 'STS_CO_06') ||
        payload.stage3status3 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 3';
        ticketPayload['associated'] = payload.stage3Associated3;
        ticketPayload['activity'] = 'AIS-140 Certification';
        ticketPayload['status'] = payload.stage3status3;
        ticketPayload['remark'] = payload.stage3remark3;
      } else if (
        (!this.myActivationsDetailsForm.get('stage3status2')?.disabled &&
          payload.stage3status2 !== 'STS_CO_06') ||
        payload.stage3status2 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 3';
        ticketPayload['associated'] = payload.stage3Associated2;
        ticketPayload['activity'] = 'AIS-140 Certification';
        ticketPayload['status'] = payload.stage3status2;
        ticketPayload['remark'] = payload.stage3remark2;
      } else if (
        (!this.myActivationsDetailsForm.get('stage3status1')?.disabled &&
          payload.stage3status1 !== 'STS_CO_06') ||
        payload.stage3status1 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 3';
        ticketPayload['associated'] = payload.stage3Associated1;
        ticketPayload['activity'] = 'AIS-140 Certification';
        ticketPayload['status'] = payload.stage3status1;
        ticketPayload['remark'] = payload.stage3remark1;
      } else if (
        (!this.myActivationsDetailsForm.get('stage2status2')?.disabled &&
          payload.stage2status2 !== 'STS_CO_06') ||
        payload.stage2status2 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 2';
        ticketPayload['associated'] = payload.stage2Associated2;
        ticketPayload['activity'] = 'Vahan Certification';
        ticketPayload['status'] = payload.stage2status2;
        ticketPayload['remark'] = payload.stage2remark2;
      } else if (
        (!this.myActivationsDetailsForm.get('stage2status1')?.disabled &&
          payload.stage2status1 !== 'STS_CO_06') ||
        payload.stage2status1 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 2';
        ticketPayload['associated'] = payload.stage2Associated1;
        ticketPayload['activity'] = 'Vahan Certification';
        ticketPayload['status'] = payload.stage2status1;
        ticketPayload['remark'] = payload.stage2remark1;
      } else if (
        (!this.myActivationsDetailsForm.get('stage1status3')?.disabled &&
          payload.stage1status3 !== 'STS_CO_06') ||
        payload.stage1status3 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 1';
        ticketPayload['associated'] = payload.stage1Associated3;
        ticketPayload['activity'] = 'FOTA / OTA Activities';
        ticketPayload['status'] = payload.stage1status3;
        ticketPayload['remark'] = payload.stage1remark3;
      } else if (
        (!this.myActivationsDetailsForm.get('stage1status2')?.disabled &&
          payload.stage1status2 !== 'STS_CO_06') ||
        payload.stage1status2 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 1';
        ticketPayload['associated'] = payload.stage1Associated2;
        ticketPayload['activity'] = 'FOTA / OTA Activities';
        ticketPayload['status'] = payload.stage1status2;
        ticketPayload['remark'] = payload.stage1remark2;
      } else if (
        (!this.myActivationsDetailsForm.get('stage1status1')?.disabled &&
          payload.stage1status1 !== 'STS_CO_06') ||
        payload.stage1status1 === 'STS_CO_06'
      ) {
        ticketPayload['stage'] = 'Stage 1';
        ticketPayload['associated'] = payload.stage1Associated1;
        ticketPayload['activity'] = 'FOTA / OTA Activities';
        ticketPayload['status'] = payload.stage1status1;
        ticketPayload['remark'] = payload.stage1remark1;
      }
      ticketPayload['certificateStartDate'] = this.myActivationsDetailsForm.get(
        'certificateStartDate'
      )?.value;
      ticketPayload['certificateExpiryDate'] =
        this.myActivationsDetailsForm.get('certificateExpiryDate')?.value;
      ticketPayload['remarkbyaccolade'] = payload.remarkbyaccolade;
      ticketPayload['imei'] = this.imei;
      ticketPayload['refId'] = this.ticketRefId;
      ticketPayload['userRef'] = this.loggedId;
      ticketPayload['fotaBatchRef'] = payload.fotaBatchRef;
      this.apiMicroservice
        .addTicketStage(ticketPayload)
        .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res.status) {
            this.apiMicroservice.openSnackbar(res.message);
          } else {
            this.apiMicroservice.openSnackbar('Operation Failed');
          }
          this.ngOnInit();
        });
    } else {
      SharedValidators.markAllAsTouched(this.myActivationsDetailsForm);
    }
  }

  openBackendCertificatePopUp() {
    document
      ?.getElementById('generateBackendCertificates')
      ?.parentElement?.classList?.add('active');
  }

  closeModal() {
    document
      ?.getElementById('generateBackendCertificates')
      ?.parentElement?.classList?.remove('active');
    document
      ?.getElementById('ticketHistory')
      ?.parentElement?.classList?.remove('active');
  }

  openDeviceStatusHistoryPopUp() {
    this.spinner.show();
    this.apiMicroservice
      .getDeviceByTicketPagination(this.ticketNo, this.vinNo)
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.data) {
            this.ticketHistoryData = res.data;
            this.totalLength = res.data.totalItems;
          }
          document
            ?.getElementById('ticketHistory')
            ?.parentElement?.classList?.add('active');
        },
        error: (error) => {
          this.spinner.hide();
          this.apiMicroservice.openSnackbar(
            error.error.message || 'Operation Failed'
          );
        },
      });
  }

  // A stage row either has a real user attached (userId, populated to
  // firstName/lastName by the backend) or was written by an automated
  // process (triggeredBy) - older rows written before this tracking
  // existed have neither, so fall back to '--' like every other column.
  getChangedByLabel(item: {
    userId?: { firstName?: string; lastName?: string } | null;
    triggeredBy?: string;
  }): string {
    if (item.userId) {
      return `${item.userId.firstName || ''} ${item.userId.lastName || ''}`.trim();
    }
    return item.triggeredBy || '--';
  }

  onPageChange(event: number) {
    this.page = event;
  }

  onSizeChange(event: number) {
    this.page = 1;
    this.size = event;
  }

  DownloadOutputReport() {
    this.spinner.show();

    const outputData = this.ticketHistoryData.map(
      (
        item: {
          ticketNo?: string;
          stage?: string;
          activity?: string;
          associated?: string;
          status?: string;
          remark?: string;
          overAllStatus?: string;
          timeStamp?: string;
          userId?: { firstName?: string; lastName?: string } | null;
          triggeredBy?: string;
        },
        index
      ) => {
        const obj = {
          'Sr. NO': index + 1,
          'Ticket No': item.ticketNo || '',
          Stage: item.stage || '',
          Activity: item.activity || '',
          'Associated Activity': item.associated || '',
          'Associated Activity Status': item.status
            ? this.simplifiedTicketStatus[item.status] || ''
            : '',
          'Associated Activity Remark': item.remark || '',
          'Overall Ticket Status': item.overAllStatus
            ? this.simplifiedTicketStatus[item.overAllStatus] || ''
            : '',
          'Changed By': this.getChangedByLabel(item),
          'Date & Time': item.timeStamp
            ? new Date(item.timeStamp).toLocaleString('en-GB', {
                timeZone: 'Asia/Kolkata',
                hour12: true,
              })
            : '',
        };
        return obj;
      }
    );
    exportAsCsvFile(outputData, `Ticket_Stage_History_Report_${this.ticketNo}`);
    this.spinner.hide();
  }

  async getIgnitionStatus() {
    try {
      this.spinner.show();
      this.apiMicroservice.getIgnitionStatus(this.vinNo).subscribe({
        next: (res) => {
          this.ignitionStatus = res.ignitionOn;
          this.spinner.hide();
        },
        error: (err) => {
          this.spinner.hide();
          console.error('Error fetching ignition status:', err);
        },
      });
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  stage2Complete() {
    const payload = this.myActivationsDetailsForm.getRawValue();
    if (payload.stage2status2 === 'STS_CO_06') {
      this.myActivationsDetailsForm.controls['stageSecond'].setValue(true);
    }
  }

  toExpiryDateChange() {
    const payload = this.myActivationsDetailsForm.getRawValue();
    const fDate = new Date(payload.certificateStartDate);
    const tDate = new Date(payload.certificateExpiryDate);

    if (fDate != tDate) {
      if (tDate <= fDate && payload.certificateStartDate !== '') {
        this.apiMicroservice.openSnackbar(
          'Expiry Date should be Greater than Start Date'
        );
        this.myActivationsDetailsForm
          ?.get('certificateExpiryDate')
          ?.setValue('');
      }
    }
  }

  setCertificateDate() {
    try {
      if (this.certificateExpiryTime !== '') {
        const year = +this.certificateExpiryTime;
        let currentDate = new Date();
        if (this.myActivationsDetailsForm.value.certificateStartDate) {
          currentDate = new Date(
            this.myActivationsDetailsForm.value.certificateStartDate
          );
        }
        const futureDate = new Date(
          currentDate.getFullYear() + year,
          currentDate.getMonth(),
          currentDate.getDate() - 1
        );
        this.myActivationsDetailsForm.controls['certificateStartDate'].setValue(
          currentDate
        );
        this.myActivationsDetailsForm.controls[
          'certificateExpiryDate'
        ].setValue(futureDate);
      } else {
        this.myActivationsDetailsForm.controls['certificateStartDate'].setValue(
          ''
        );
        this.myActivationsDetailsForm.controls[
          'certificateExpiryDate'
        ].setValue('');
      }
    } catch (error) {
      console.error(error);
    }
  }

  ticketInfoToggle() {
    this.ticketInfoDrop = !this.ticketInfoDrop;
  }

  deviceInfoToggle() {
    this.deviceInfoDrop = !this.deviceInfoDrop;
  }

  ownerInfoToggle() {
    this.ownerInfoDrop = !this.ownerInfoDrop;
  }

  vehicleInfoToggle() {
    this.vehicleInfoDrop = !this.vehicleInfoDrop;
  }

  dealerInfoToggle() {
    this.dealerInfoDrop = !this.dealerInfoDrop;
  }
  fotaStatusInfoToggle() {
    this.fotaStatusInfoDrop = !this.fotaStatusInfoDrop;
  }

  async checkStageToggle() {
    if (
      !this.myActivationsDetailsForm.get('stage1status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage1status2')?.disabled ||
      !this.myActivationsDetailsForm.get('stage1status3')?.disabled
    ) {
      this.stage1Drop = true;
      if (!this.myActivationsDetailsForm.get('stage1status1')?.disabled) {
        this.myActivationsDetailsForm
          .get('stage1status1')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage1status1')
          ?.updateValueAndValidity();
      } else if (
        !this.myActivationsDetailsForm.get('stage1status2')?.disabled
      ) {
        this.myActivationsDetailsForm
          .get('stage1status2')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage1status2')
          ?.updateValueAndValidity();
      } else if (
        !this.myActivationsDetailsForm.get('stage1status3')?.disabled
      ) {
        this.myActivationsDetailsForm
          .get('stage1status3')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage1status3')
          ?.updateValueAndValidity();
      }
    } else {
      this.stage1Drop = false;
    }
    if (
      !this.myActivationsDetailsForm.get('stage2status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage2status2')?.disabled
    ) {
      this.stage2Drop = true;
      if (!this.myActivationsDetailsForm.get('stage2status1')?.disabled) {
        this.myActivationsDetailsForm
          .get('stage2status1')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage2status1')
          ?.updateValueAndValidity();
      } else if (
        !this.myActivationsDetailsForm.get('stage2status2')?.disabled
      ) {
        this.myActivationsDetailsForm
          .get('stage2status2')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage2status2')
          ?.updateValueAndValidity();
      }
    } else {
      this.stage2Drop = false;
    }
    if (
      !this.myActivationsDetailsForm.get('stage3status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage3status2')?.disabled ||
      !this.myActivationsDetailsForm.get('stage3status3')?.disabled
    ) {
      this.stage3Drop = true;
      if (!this.myActivationsDetailsForm.get('stage3status1')?.disabled) {
        this.myActivationsDetailsForm
          .get('stage3status1')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage3status1')
          ?.updateValueAndValidity();
      } else if (
        !this.myActivationsDetailsForm.get('stage3status2')?.disabled
      ) {
        this.myActivationsDetailsForm
          .get('stage3status2')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage3status2')
          ?.updateValueAndValidity();
      } else if (
        !this.myActivationsDetailsForm.get('stage3status3')?.disabled
      ) {
        this.myActivationsDetailsForm
          .get('stage3status3')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage3status3')
          ?.updateValueAndValidity();
      }
    } else {
      this.stage3Drop = false;
    }
    if (!this.myActivationsDetailsForm.get('stage4status1')?.disabled) {
      this.stage4Drop = true;
      if (!this.myActivationsDetailsForm.get('stage4status1')?.disabled) {
        this.myActivationsDetailsForm
          .get('stage4status1')
          ?.setValidators([Validators.required]);
        this.myActivationsDetailsForm
          .get('stage4status1')
          ?.updateValueAndValidity();
      }
    } else {
      this.stage4Drop = false;
    }
  }

  Stage1Toggle() {
    if (
      !this.myActivationsDetailsForm.get('stage1status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage1status2')?.disabled ||
      !this.myActivationsDetailsForm.get('stage1status3')?.disabled
    ) {
      this.stage1Drop = true;
    } else {
      this.stage1Drop = !this.stage1Drop;
    }
  }

  Stage2Toggle() {
    if (
      !this.myActivationsDetailsForm.get('stage2status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage2status2')?.disabled
    ) {
      this.stage2Drop = true;
    } else {
      this.stage2Drop = !this.stage2Drop;
    }
  }

  stage3Toggle() {
    if (
      !this.myActivationsDetailsForm.get('stage3status1')?.disabled ||
      !this.myActivationsDetailsForm.get('stage3status2')?.disabled ||
      !this.myActivationsDetailsForm.get('stage3status3')?.disabled
    ) {
      this.stage3Drop = true;
    } else {
      this.stage3Drop = !this.stage3Drop;
    }
  }

  stage4Toggle() {
    if (!this.myActivationsDetailsForm.get('stage4status1')?.disabled) {
      this.stage4Drop = true;
    } else {
      this.stage4Drop = !this.stage4Drop;
    }
  }

  async markStageAsComplete(currentStage: number) {
    this.spinner.show();
    if (currentStage >= 2) {
      this.myActivationsDetailsForm.controls['stageSecond'].setValue(true);
    }
    const payload = this.myActivationsDetailsForm.getRawValue();

    const ticketPayloadBase = {
      ticketNo: this.ticketDetails.ticketNo,
      vinNo: this.ticketDetails.vinNo,
      stageSecond: this.myActivationsDetailsForm.get('stageSecond')?.value,
      certificateStartDate: this.myActivationsDetailsForm.get(
        'certificateStartDate'
      )?.value,
      certificateExpiryDate: this.myActivationsDetailsForm.get(
        'certificateExpiryDate'
      )?.value,
      remarkbyaccolade: payload.remarkbyaccolade,
      userRef: this.loggedId,
    };

    const allStages: Record<
      number,
      {
        activity: string;
        associated: string;
        isDisabled: boolean | undefined;
        status: string;
      }[]
    > = {
      1: [
        {
          activity: 'FOTA / OTA Activities',
          associated: 'Dealer Request / Vehicle Ignition On',
          isDisabled:
            this.myActivationsDetailsForm.get('stage1status1')?.disabled,
          status: this.stageSelectControl.stage1status1,
        },
        {
          activity: 'FOTA / OTA Activities',
          associated: 'GSM Network Availability',
          isDisabled:
            this.myActivationsDetailsForm.get('stage1status2')?.disabled,
          status: this.stageSelectControl.stage1status2,
        },
        {
          activity: 'FOTA / OTA Activities',
          associated: 'GPS Fix availability',
          isDisabled:
            this.myActivationsDetailsForm.get('stage1status3')?.disabled,
          status: this.stageSelectControl.stage1status3,
        },
      ],
      2: [
        {
          activity: 'Vahan Certification',
          associated: 'Vahan Portal Availability',
          isDisabled:
            this.myActivationsDetailsForm.get('stage2status1')?.disabled,
          status: this.stageSelectControl.stage2status1,
        },
        {
          activity: 'Vahan Certification',
          associated: 'Vehicle Data availability on Vahan',
          isDisabled:
            this.myActivationsDetailsForm.get('stage2status2')?.disabled,
          status: this.stageSelectControl.stage2status2,
        },
      ],
      3: [
        {
          activity: 'AIS-140 Certification',
          associated: 'Backend Portal Availability',
          isDisabled:
            this.myActivationsDetailsForm.get('stage3status1')?.disabled,
          status: this.stageSelectControl.stage3status1,
        },
        {
          activity: 'AIS-140 Certification',
          associated: 'Panic Event Confirmation',
          isDisabled:
            this.myActivationsDetailsForm.get('stage3status2')?.disabled,
          status: this.stageSelectControl.stage3status2,
        },
        {
          activity: 'AIS-140 Certification',
          associated: 'OTP / Live Location Fetching',
          isDisabled:
            this.myActivationsDetailsForm.get('stage3status3')?.disabled,
          status: this.stageSelectControl.stage3status3,
        },
      ],
      4: [
        {
          activity: 'Certificate Generation / Submission',
          associated: 'AEPL',
          isDisabled:
            this.myActivationsDetailsForm.get('stage4status1')?.disabled,
          status: this.stageSelectControl.stage4status1,
        },
      ],
    };

    const stages = allStages[currentStage] || [];
    try {
      // Process each stage
      for (const stage of stages) {
        if (stage.isDisabled && stage.status === 'STS_CO_06') continue; // Skip completed stages

        const stagePayload = {
          ...ticketPayloadBase,
          stage: `Stage ${currentStage}`,
          associated: stage.associated,
          activity: stage.activity,
          status: 'STS_CO_06',
          remark: '',
          imei: this.imei,
          refId: this.ticketRefId,
        };

        const res = await lastValueFrom(
          this.apiMicroservice.addTicketStage(stagePayload)
        );

        if (!res || !res.status) {
          throw new Error(`Failed to update stage: ${stage.associated}`);
        }
      }

      // Success notification and reload
      this.apiMicroservice.openSnackbar(
        `Stage ${currentStage} marked as Complete Successfully.`
      );
      this.ngOnInit();
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : String(error);
      this.apiMicroservice.openSnackbar('Operation Failed: ' + errorMessage);
    } finally {
      this.spinner.hide();
    }
  }

  getFotaDeviceDetails() {
    if (this.fotaForm.valid) {
      const deviceFotaData = this.fotaForm.value;
      this.updateTcu2gDeviceFotaData(deviceFotaData);
    } else {
      this.fotaForm.markAllAsTouched();
      this.apiMicroservice.openSnackbar(
        'Please fill device fota status form to update.'
      );
      return;
    }
  }

  openVahanCertificateLink() {
    window.open(
      'https://vahan.parivahan.gov.in/vltdmaker/vahan/welcome.xhtml',
      '_blank'
    );
  }

  openExternal(url: string) {
    window.open(url, '_blank');
  }

  navigateBack() {
    this.apiMicroservice.back();
  }
}
